/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import LoaderComponent from '~/components/Loader';
import api from '../../../services/api';
import { formatPrice } from '../../../util/format';

import {
  Container,
  DivBody,
  DivInput,
  StyledDebounceInput,
  DivProducts,
  DivRem,
  Card,
  ButtonAdd,
  ButtonRem,
  DivProductsOrder,
  DivProductOrder,
  DivFooter,
  ButtonSeeMore,
} from './styles';

import ResponsiveHeader from '../../../components/HeaderMobile';

import ArrowRightIcon from '../../../assets/icons/arrowRight.svg';
import CancelIcon from '../../../assets/icons/order/cancel.svg';
import NoImage from '../../../assets/icons/noimage.png';

import MinusIcon from '../../../assets/icons/order/minus.svg';
import PlusIcon from '../../../assets/icons/order/plus.svg';

const PAGE_SIZE = 20;

function OrderRegister() {
  const history = useHistory();

  const [showFooter, setShowFooter] = useState(true);
  const [showProductsOrder, setShowProductsOrder] = useState(false);

  // busca + paginação
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({ total: 0, pages: 0, hasNext: false });

  // itens da página atual (muda ao pesquisar/paginar)
  const [items, setItems] = useState([]);

  // carrinho: id -> amount (persistente mesmo mudando busca/página)
  const [amountById, setAmountById] = useState({});

  // cache de produtos já vistos/selecionados (pra montar o agregado fora da página atual)
  const [cartById, setCartById] = useState({});

  const fetchProducts = useCallback(
    async ({ nextPage, append }) => {
      setLoading(true);
      try {
        const { data } = await api.get('/linkstoorders', {
          params: {
            page: nextPage,
            limit: PAGE_SIZE,
            q: search || undefined,
          },
        });

        // suporta os dois formatos: novo ({data, meta}) ou antigo (array)
        const newItems = data?.data ?? data ?? [];
        const newMeta = data?.meta;

        setMeta(prev => ({
          total: newMeta?.total ?? prev.total,
          pages: newMeta?.pages ?? prev.pages,
          hasNext: newMeta?.hasNext ?? false,
        }));

        setItems(prev => (append ? [...prev, ...newItems] : newItems));

        // merge no cache (mantém detalhes atualizados de tudo que já apareceu)
        setCartById(prev => {
          const next = { ...prev };
          for (const p of newItems) next[p.id] = p;
          return next;
        });
      } finally {
        setLoading(false);
      }
    },
    [search]
  );

  // primeira carga + quando muda busca
  useEffect(() => {
    setPage(1);
    fetchProducts({ nextPage: 1, append: false });
  }, [fetchProducts]);

  // lista exibida (página atual) com amount do carrinho
  const productsWithAmount = useMemo(() => {
    return (items || []).map(p => ({
      ...p,
      amount: amountById[p.id] || 0,
    }));
  }, [items, amountById]);

  // agregado do pedido (NÃO depende da página atual)
  const selectedProducts = useMemo(() => {
    return Object.entries(amountById)
      .map(([id, amount]) => {
        const product = cartById[id];
        if (!product) return null; // raro (ex: refresh e não carregou esse id ainda)
        return { ...product, amount };
      })
      .filter(Boolean);
  }, [amountById, cartById]);

  const totalNumber = useMemo(() => {
    return selectedProducts.reduce((sum, p) => {
      const price = Number(p.promotion_price || p.price || 0);
      return sum + price * p.amount;
    }, 0);
  }, [selectedProducts]);

  const totalFormatted = useMemo(() => formatPrice(totalNumber), [totalNumber]);

  function handleAddAmountProduct(product) {
    // garante que o produto fica disponível no agregado mesmo quando mudar busca/página
    setCartById(prev => ({ ...prev, [product.id]: product }));

    setAmountById(prev => ({
      ...prev,
      [product.id]: (prev[product.id] || 0) + 1,
    }));
  }

  function handleRemAmountProduct(id) {
    setAmountById(prev => {
      const next = { ...prev };
      const current = next[id] || 0;
      const newValue = Math.max(current - 1, 0);

      if (newValue === 0) delete next[id];
      else next[id] = newValue;

      return next;
    });
  }

  async function handleLoadMore() {
    if (loading || !meta.hasNext) return;
    const nextPage = page + 1;
    setPage(nextPage);
    await fetchProducts({ nextPage, append: true });
  }

  async function handleSubmit() {
    await api.post('/orderrequestmanual', {
      total: totalNumber, // melhor enviar número
      cart: selectedProducts.map(p => ({
        id: p.id,
        title: p.title,
        amount: p.amount,
        price: p.price,
        promotion_price: p.promotion_price,
        images: p.images,
      })),
    });

    history.push('/myorders');
  }

  return (
    <Container>
      <ResponsiveHeader title="Registrar pedido" url="/myorders" tab={1} />

      <DivBody>
        <DivInput>
          <StyledDebounceInput
            placeholder="Buscar produto"
            minLength={1}
            debounceTimeout={500}
            onChange={e => setSearch(e.target.value)}
          />
        </DivInput>

        <DivProducts>
          {productsWithAmount.map(p => (
            <Card key={p.id}>
              {p.amount > 0 && (
                <DivRem>
                  <ButtonRem onClick={() => handleRemAmountProduct(p.id)}>
                    <img src={MinusIcon} alt="minus" />
                  </ButtonRem>
                </DivRem>
              )}

              <div className="body" onClick={() => handleAddAmountProduct(p)}>
                <img
                  src={
                    (p.images && p.images[0] && p.images[0].image_url) ||
                    NoImage
                  }
                  alt=""
                />

                <div>
                  <strong>{p.title}</strong>
                  <span>{p.promotion_price || p.price}</span>
                </div>

                <ButtonAdd active={p.amount > 0}>
                  {p.amount > 0 ? p.amount : <img src={PlusIcon} alt="plus" />}
                </ButtonAdd>
              </div>
            </Card>
          ))}

          {meta.hasNext && (
            <ButtonSeeMore
              type="button"
              disabled={loading}
              onClick={handleLoadMore}
            >
              {loading ? <LoaderComponent size={20} /> : 'Ver mais'}
            </ButtonSeeMore>
          )}

          {!loading && productsWithAmount.length === 0 && (
            <div style={{ padding: 12, opacity: 0.7 }}>
              Nenhum produto encontrado.
            </div>
          )}
        </DivProducts>
      </DivBody>

      {showProductsOrder && (
        <DivProductsOrder>
          <div>
            <header>
              <strong>Informações do pedido</strong>
              <img
                src={CancelIcon}
                alt="cancel"
                onClick={() => {
                  setShowFooter(true);
                  setShowProductsOrder(false);
                }}
              />
            </header>
            <span>Produtos</span>

            <DivProductOrder>
              {selectedProducts.map(p => (
                <div key={p.id}>
                  <img
                    src={
                      (p.images && p.images[0] && p.images[0].image_url) ||
                      NoImage
                    }
                    alt="images"
                  />

                  <div>
                    <strong>
                      {p.amount > 1 ? `${p.amount}x` : ''} {p.title}
                    </strong>
                    <span>{p.promotion_price || p.price}</span>
                  </div>
                </div>
              ))}
            </DivProductOrder>
          </div>
        </DivProductsOrder>
      )}

      {showFooter && (
        <DivFooter hasBackground={selectedProducts.length > 0}>
          {selectedProducts.length > 0 && (
            <button
              type="button"
              className="see-order"
              onClick={() => {
                setShowFooter(false);
                setShowProductsOrder(true);
              }}
            >
              <strong>Ver pedido</strong>
            </button>
          )}

          <button
            type="button"
            disabled={selectedProducts.length === 0}
            onClick={handleSubmit}
          >
            <span>{totalFormatted}</span>
            <strong>Registrar pedido</strong>
            <img src={ArrowRightIcon} alt="arrow" />
          </button>
        </DivFooter>
      )}
    </Container>
  );
}

export default OrderRegister;
